module.exports = __webpack_public_path__ + "img/header/qua-watermark.svg";